import { create } from 'zustand'

interface ICollectorItem {
  key: string
  callback: () => void
}

interface IGarbageCollectorStore {
  collectors: { key: string; callback: () => void }[]
  add: (item: ICollectorItem) => void
  remove: (key: string) => void
  run: (key: string) => void
  runAll: () => void
  purge: () => void
}

export const useGarbageCollectorStore = create<IGarbageCollectorStore>((set, get) => ({
  collectors: [],
  add: (item: ICollectorItem) => {
    const { collectors } = get()
    const cloned = [...collectors]

    const index = cloned.findIndex((c) => c.key)

    if (index === -1) {
      set({ collectors: [...cloned, item] })
    } else {
      try {
        cloned[index].callback()
      } catch {
        // ignore
      }

      cloned[index] = item
      set({ collectors: cloned })
    }
  },
  remove: (key: string) => {
    const { collectors } = get()

    const cloned = [...collectors.filter((c) => c.key !== key)]

    set({ collectors: cloned })
  },
  run: (key: string) => {
    const { collectors } = get()
    const item = collectors.find((c) => c.key === key)

    if (item) {
      console.log(`Running garbage collection on: ${item?.key}`)

      item.callback()
    }
  },
  runAll: () => {
    const { collectors } = get()

    for (let i = 0; i < collectors.length; i++) {
      const { key, callback } = collectors[i]

      console.log('Running garbage collection on: ', key)

      callback()
    }
    set({ collectors: [] })
  },
  purge: () => {
    set({ collectors: [] })
  }
}))
